import { Link, Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

interface Props {
  /** Last breadcrumb segment (current page). */
  title: string;
  /** Renders the page headline (26px) below the breadcrumb. */
  showTitle?: boolean;
}

const AdminSubpageHeader: React.FC<Props> = ({ title, showTitle = false }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1} sx={{ mb: showTitle ? 0 : 2 }}>
      <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ fontSize: 13, color: 'greys.medium' }}>
        <Link
          component={RouterLink}
          to={Routes.ADMINISTRATION}
          underline={'hover'}
          sx={{ fontSize: 13, color: 'primary.main' }}
        >
          {t('administration')}
        </Link>
        <Typography component={'span'} sx={{ fontSize: 13, color: 'greys.medium' }}>
          /
        </Typography>
        <Typography component={'span'} sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}>
          {title}
        </Typography>
      </Stack>
      {showTitle ? (
        <Typography sx={{ fontSize: 26, fontWeight: 500, letterSpacing: '-0.2px', color: 'text.primary' }}>
          {title}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default AdminSubpageHeader;
